import type { ReactNode } from "react";

export interface Column<Item> {
  header: string;
  cell: (item: Item) => ReactNode;
  numeric?: boolean;
}

interface TableProps<Item> {
  columns: Column<Item>[];
  items: Item[];
  rowKey: (item: Item) => string;
  onRowClick?: (item: Item) => void;
  empty?: ReactNode;
  footer?: ReactNode[];
}

export function Table<Item>({ columns, items, rowKey, onRowClick, empty, footer }: TableProps<Item>) {
  return (
    <div className="ds-table-wrap">
      <table className="ds-table">
        <thead>
          <tr>{columns.map((column) => <th key={column.header} className={column.numeric ? "ds-num" : undefined}>{column.header}</th>)}</tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr><td colSpan={columns.length}>{empty}</td></tr>
          ) : (
            items.map((item) => (
              <tr key={rowKey(item)} data-clickable={onRowClick ? "true" : undefined} onClick={onRowClick ? () => onRowClick(item) : undefined}>
                {columns.map((column) => <td key={column.header} className={column.numeric ? "ds-num" : undefined}>{column.cell(item)}</td>)}
              </tr>
            ))
          )}
          {footer && items.length > 0 ? <tr data-total="true">{footer.map((cell, index) => <td key={index} className={columns[index]?.numeric ? "ds-num" : undefined}>{cell}</td>)}</tr> : null}
        </tbody>
      </table>
    </div>
  );
}
